// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2022 MobiledgeX, Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.terms {
    background-color: #2A2C34;
    height: 100vh;
}

.terms .top-header {
    height: 500px;
    width: 100vw;
    top:0;
    background-color: #2A2C34;
}

.terms .top-header .logo {
    margin-top: 25px;
    width: 300px;
}

.terms .main {
    position: absolute;
    padding: 10px;
    top:110px;
    right:0;
    left:0;
    margin-left: 20%;
    margin-right: 20%;
    border-radius: 5px;
    height: calc(99vh - 110px);
    padding-top: 20px;
    overflow-y: auto;
    background-color: #FFF;
}

.terms .main ul {
    list-style-type: none;
    padding-left: 0;
}
.terms .main li {
    margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/landing/policy/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,KAAK;IACL,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,OAAO;IACP,MAAM;IACN,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,eAAe;AACnB","sourcesContent":["/**\n * Copyright 2022 MobiledgeX, Inc\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.terms {\n    background-color: #2A2C34;\n    height: 100vh;\n}\n\n.terms .top-header {\n    height: 500px;\n    width: 100vw;\n    top:0;\n    background-color: #2A2C34;\n}\n\n.terms .top-header .logo {\n    margin-top: 25px;\n    width: 300px;\n}\n\n.terms .main {\n    position: absolute;\n    padding: 10px;\n    top:110px;\n    right:0;\n    left:0;\n    margin-left: 20%;\n    margin-right: 20%;\n    border-radius: 5px;\n    height: calc(99vh - 110px);\n    padding-top: 20px;\n    overflow-y: auto;\n    background-color: #FFF;\n}\n\n.terms .main ul {\n    list-style-type: none;\n    padding-left: 0;\n}\n.terms .main li {\n    margin-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
